import { render, staticRenderFns } from "./LabelBN.vue?vue&type=template&id=1707512e&scoped=true&"
import script from "./LabelBN.vue?vue&type=script&lang=ts&"
export * from "./LabelBN.vue?vue&type=script&lang=ts&"
import style0 from "./LabelBN.vue?vue&type=style&index=0&id=1707512e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707512e",
  null
  
)

export default component.exports